<div class="card shadow p-4 mt-4">
    <h4 class="mb-3">Working Hours</h4>
    <div class="table-responsive">
      <table class="table table-bordered text-center">
        <thead class="table-light">
          <tr>
            <th>Day</th>
            <th>Active</th>
            <th>Start Time</th>
            <th>End Time</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let workingDay of workingDays" [ngClass]="{ 'table-danger': invalidDays?.has(workingDay.day)}">
            <td class="align-middle">{{ workingDay.day }}</td>
            <td class="align-middle">
              <input type="checkbox"
                  [(ngModel)]="workingDay.isActive"
                  [disabled]="!canEditWorkingDays"
                  (ngModelChange)="onWorkingDayChanged()">
            </td>
            <td class="align-middle">
              <input type="time"
                  class="form-control"
                  [(ngModel)]="workingDay.startTime"
                  [disabled]="!canEditWorkingDays || !workingDay.isActive"
                  (ngModelChange)="onWorkingDayChanged()"
                  [attr.title]="invalidDays?.has(workingDay.day) ? (invalidDayTitle ?? null) : null">
            </td>
            <td class="align-middle">
              <input type="time"
                  class="form-control"
                  [(ngModel)]="workingDay.endTime"
                  [disabled]="!canEditWorkingDays || !workingDay.isActive"
                  (ngModelChange)="onWorkingDayChanged()"
                  [attr.title]="invalidDays?.has(workingDay.day) ? (invalidDayTitle ?? null) : null">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</div>

<!-- Exceptions -->
<div class="card shadow p-4 mt-3">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h5 class="mb-0">Exceptions / Closed Days</h5>
    <button class="btn btn-outline-primary btn-sm" (click)="addException()" >
      <i class="bi bi-plus-lg me-1"></i>Add free day
    </button>
  </div>

  <div class="table-responsive">
    <table class="table table-bordered align-middle exceptions-table">
      <thead class="table-light text-center">
        <tr>
          <th style="width: 180px;">Type</th>
          <th style="width: 170px;">Start date</th>
          <th style="width: 170px;">End date</th>
          <th style="width: 140px;">Repeat Yearly</th>
          <th>Description</th>
          <th style="width: 70px;">Actions</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let ex of exceptions; let i = index; trackBy: trackByIndex"
            [class.table-danger]="ex._invalid"
            [class.table-warning]="ex._overlaps?.length">

          <td>
            <select class="form-select"
                [(ngModel)]="ex.type"
                (ngModelChange)="revalidateAll()">
              <option *ngFor="let t of exceptionTypes" [ngValue]="t">
                {{ t }}
              </option>
            </select>
          </td>

          <td>
            <input type="date" class="form-control" [ngModel]="ex.startDate" (ngModelChange)="onStartDateChange(ex, $event)" />
          </td>

          <td>
            <input type="date" class="form-control" [(ngModel)]="ex.endDate" [min]="ex.startDate" (ngModelChange)="onDateChange(ex)" />
          </td>

          <td class="text-center align-middle">
            <div class="form-check d-inline-flex justify-content-center">
              <input class="form-check-input" type="checkbox" [(ngModel)]="ex.repeatYearly" (ngModelChange)="revalidateAll()" />
            </div>
          </td>

          <td>
            <input type="text" class="form-control" placeholder="Optional note" [(ngModel)]="ex.description" (ngModelChange)="emit()" />

            <div class="form-text text-danger" *ngIf="ex._invalid">
              End date must be on or after start date.
            </div>
            <div class="form-text text-warning" *ngIf="ex._overlaps?.length">
              Overlaps with {{ ex._overlaps?.length }} other exception(s).
            </div>
          </td>

          <td class="text-center">
            <button class="btn btn-outline-danger btn-sm" (click)="removeException(i)" title="Remove">
              <i class="bi bi-trash"></i>
            </button>
          </td>
        </tr>

        <tr *ngIf="!exceptions?.length" class="text-center">
          <td colspan="6" class="text-muted">No exceptions yet — add your first “free day”.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="d-flex gap-2 flex-wrap">
    <button class="btn btn-outline-secondary btn-sm" (click)="addToday()">
      <i class="bi bi-calendar-day me-1"></i>Add today
    </button>
    <button class="btn btn-outline-secondary btn-sm" (click)="addWeekend()">
      <i class="bi bi-calendar-week me-1"></i>Add next weekend
    </button>
    <button class="btn btn-outline-secondary btn-sm" (click)="addRange(5)">
      <i class="bi bi-calendar-range me-1"></i>Add 5-day vacation
    </button>
  </div>
</div>
